import {
  Button,
  Card,
  components,
  Flex,
  Label,
  SearchSelect,
  Span
} from '@fareye/ui'
import React from 'react'
import { tzFormat } from '@fareye/utils'
import enUS from 'date-fns/locale/en-US'
import { TIMEZONE_KEY } from '../../config/constants'
import data from './timezone.json'
const fix_date_dummy = new Date()
const Option = (props: any) => {
  const TZ_DISPLAY = tzFormat(fix_date_dummy, 'z', {
    timeZone: props?.data?.utc[0],
    locale: enUS
  })
  return (
    <div>
      <components.Option {...props}>
        <Flex style={{ width: '100%' }}>
          <Label width="35%">{`${props?.data?.utc[0]}`}</Label>
          <Label width="35%">{props?.data?.value}</Label>
          <Label style={{ marginLeft: 'auto' }}>
            {TZ_DISPLAY} (GMT{props?.data?.offset})
          </Label>
        </Flex>
      </components.Option>
    </div>
  )
}
const SingleValue = ({ children, ...props }: any) => (
  <components.SingleValue {...props}>
    <Span
      style={{
        padding: 5,
        borderRadius: 5,
        color: 'white',
        backgroundColor: '#2684FF',
        display: 'flex',
        fontWeight: 600,
        fontSize: '14px'
      }}
    >
      {props?.data?.text}
    </Span>
  </components.SingleValue>
)
export default function TimeZoneList({ state, setState, setToggleModal }: any) {
  const recordsToShow = 8
  let flag = 0
  const [selectedTimezone, setSelectedTimezone] = React.useState(state)
  function handleSubmit(selectedTimezone: any) {
    let data = {
      id: 'others',
      text: selectedTimezone.value,
      value: selectedTimezone.utc[0],
      displayText: selectedTimezone.utc[0]
    }
    setState(data)
    setToggleModal(false)
    localStorage.setItem(TIMEZONE_KEY, JSON.stringify(data))
  }
  const header = () => {
    return <Label p={3}>Select Timezone</Label>
  }
  const footer = () => {
    return (
      <Flex p={2} justifyContentFlexEnd>
        <Button
          variant="primary"
          onClick={() => handleSubmit(selectedTimezone)}
        >
          Submit
        </Button>
      </Flex>
    )
  }
  return (
    <Card
      bodyStyle={{
        minHeight: '300px',
        backgroundColor: '#FBFBFB'
      }}
      variant="m"
      header={header()}
      footer={footer()}
    >
      <SearchSelect
        value={selectedTimezone}
        components={{
          Option,
          SingleValue,
          IndicatorSeparator: () => null,
          DropdownIndicator: () => null
        }}
        filterOption={({ label }, query) => {
          return label
            ? label.toLowerCase().indexOf(query.toLowerCase()) >= 0 &&
                flag + 1 < recordsToShow
            : false
        }}
        getOptionLabel={ele => ele.value + ' ' + ele.utc?.[0] + ' ' + ele.abbr}
        getOptionValue={ele => ele.utc?.[0] + ' ' + ele.abbr}
        onInputChange={() => {
          flag = 0
        }}
        menuIsOpen={true}
        options={data.filter((item: any) => item.enable)}
        onChange={data => setSelectedTimezone(data)}
        placeholder="Please Select a Timezone"
        isMulti={false}
      ></SearchSelect>
    </Card>
  )
}
